import React from 'react'

const Header = ({isAuthenticated, logout}) => (
    <header>
        {isAuthenticated && <button id="logout" onClick={logout}>Logout</button>}
        <div className="spacebox">
            <div id="mm-logo"></div>
            <h1>Campaign Preview</h1>
        </div>
    </header>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/layout/Header.js